<template>
    <div v-loading="loading" class="product-variations">
        <transition mode="out-in" name="fade">
            <div v-if="addMode" key="addMode">
                <div class="row">
                    <div class="col-md-12">
                        <el-form ref="formAdd" :model="formAdd" :rules="formAddRules" label-width="200px">
                            <el-form-item label="Variation" prop="variation_value_id" required>
                                <el-select v-model="formAdd.variation_value_id" filterable placeholder="Variation">
                                    <el-option v-for="item in variationSize.values" :key="item.id" :label="item.value"
                                               :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="ShopID" prop="shop_id">
                                <el-input v-model="formAdd.shop_id"></el-input>
                            </el-form-item>
                            <el-form-item label="Prix" prop="mf_price_public">
                                <el-input v-model="formAdd.mf_price_public"></el-input>
                            </el-form-item>
                            <el-form-item label="Code barre" prop="ean13">
                                <el-input v-model="formAdd.ean13"></el-input>
                            </el-form-item>
                            <el-form-item label="Référence fournisseur (Logyone)" prop="external_ref">
                                <el-input v-model="formAdd.external_ref"></el-input>
                            </el-form-item>
                            <el-form-item label="Référence fabricant" prop="manufacturer_ref">
                                <el-input v-model="formAdd.manufacturer_ref"></el-input>
                            </el-form-item>
                            <el-form-item label="Date dispo Speedway" prop="date_dispo_pim">
                                <el-input v-model="formAdd.date_dispo_pim"></el-input>
                            </el-form-item>
                            <div class="pull-right">
                                <button class="btn btn-outline-secondary" @click.prevent="cancelAdd">Annuler</button>
                                <button class="btn btn-outline-primary" @click.prevent="saveAdd">Ajouter</button>
                            </div>
                            <div class="clearfix"></div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div v-else key="listMode">

                <div v-if="hasSelection" class="pull-left">
                    <button v-if="user.can('edit product variations delete')" class="btn btn-outline-danger"
                            @click.prevent="removeAll">Supprimer
                    </button>
                </div>
                <div class="pull-right">
                    <button v-if="hasEditMode" class="btn btn-outline-secondary " @click.prevent="cancelEditMode">
                        Annuler l'edition
                    </button>
                    <button v-if="hasEditMode" class="btn btn-outline-success " @click.prevent="saveAll">Sauvegarder
                    </button>
                    <button v-if="user.can('edit product variations') && !hasEditMode" class="btn btn-outline-secondary"
                            @click.prevent="editAll">Editions
                    </button>
                    <button v-if="user.can('edit product variations add')" class="btn btn-outline-primary"
                            @click.prevent="add">Ajouter une variation
                    </button>
                    <template v-if="hasEditMode && user.can('edit product variations mf_price_public')">
                        <div class="row mt-3">
                            <div class="col-3 p-0">
                                <el-input v-model="mf_price_public" placeholder="Prix de vente HT">
                                    <el-button slot="append" icon="el-icon-check"
                                               @click.prevent="applyPrice"></el-button>
                                </el-input>
                            </div>
                            <div class="col-3 ml-2 p-0">
                                <el-input v-model="price_speedway" placeholder="Prix Speedway HT">
                                    <el-button slot="append" icon="el-icon-check"
                                               @click.prevent="applyPrice"></el-button>
                                </el-input>
                            </div>
                            <div class="col-3 ml-2 p-0">
                                <el-input v-model="paht" placeholder="Prix d'achat HT">
                                    <el-button slot="append" icon="el-icon-check"
                                               @click.prevent="applyPrice"></el-button>
                                </el-input>
                            </div>
                        </div>

                    </template>

                    <label class='ml-4'>
                        <el-switch v-model='show_deleted_variations' />
                        Afficher les <strong>{{ variationsDeleted.length }}</strong> variations supprimmées.
                    </label>

                </div>
                <div class="clearfix"></div>
                <div class="mb-2 text-right">
                    <button :title="showAllColumns ? 'Masquer les colonnes' : 'Afficher toutes les colonnes'"
                            class="btn btn-sm btn-outline-info"
                            @click.prevent="handleShowAllColumns">
                        <i :class="showAllColumns ? 'fe fe-minus' : 'fe fe-plus'"></i>
                        {{ showAllColumns ? 'Masquer les colonnes supplémentaires' : 'Afficher toutes les colonnes' }}
                    </button>
                </div>
                <div :class="{'table-wrapper-overflow': showAllColumns}">
                    <el-table
                        v-if="showTable"
                        ref="tableVariations"
                        :data="variationsParsed"
                        :row-class-name='addRowClass'
                        stripe
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                        @row-dblclick="(row, event)=> edit(row)"
                    >
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column label="ID Speedway">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    {{ scope.row.shop_id }}
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations shop_id')">
                                    <el-input v-model="scope.row.datasEditInline.shop_id"
                                              placeholder="ShopID"></el-input>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="Stock">
                            <template slot-scope="scope">
                                <div>
                                    <small>PIM :</small>
                                    <strong v-if="scope.row.has_stock" class="text-success">Oui</strong>
                                    <strong v-if="!scope.row.has_stock" class="text-danger">Non</strong>
                                    <div v-if="scope.row.date_dispo_fourn">
                                        <i class="fe fe-watch"></i> : {{ scope.row.date_dispo_fourn_human }}
                                    </div>
                                </div>
                                <div>
                                    <svg id="Calque_1" style="height: 12px; fill:cadetblue" version="1.1"
                                         viewBox="0 0 80 52.71" x="0px"
                                         xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink" y="0px">
                                <g>
                                    <path class="st0" d="M67.98,2.91C65.55,0.97,62.09,0,57.62,0H46.54h-3.53H24.89c-3.23,0-6.04,0.49-8.45,1.47
		c-2.4,0.98-4.25,2.36-5.55,4.15s-1.95,3.87-1.95,6.24c0,1.96,0.51,3.54,1.54,4.74s2.25,2.1,3.68,2.68
		c1.42,0.59,3.21,1.16,5.36,1.73c1.9,0.51,3.3,0.98,4.2,1.42s1.35,1.06,1.35,1.85c0,0.92-0.5,1.64-1.49,2.16
		c-0.37,0.2-1.06,0.35-1.77,0.48c-1.24,0.21-2.5,0.31-3.76,0.31H1.46L0,34.54h18.48c3.19,0,6-0.49,8.42-1.47s4.29-2.36,5.6-4.15
		s1.97-3.85,1.97-6.19c0-1.9-0.51-3.43-1.52-4.6c-1.01-1.17-2.22-2.04-3.63-2.61c-1.41-0.57-3.19-1.12-5.34-1.66
		c-1.93-0.5-3.35-0.98-4.27-1.42s-1.38-1.08-1.38-1.9c0-0.95,0.53-1.72,1.59-2.32s2.52-0.9,4.39-0.9L41.55,7.3h9.73h5.13
		c1.74,0,3.08,0.35,4.02,1.06c0.94,0.71,1.41,1.77,1.41,3.18c0,1.87-0.58,3.32-1.75,4.34s-2.92,1.94-5.09,1.94h-5.89l1.34-5.96
		h-9.74l-1.27,5.96l-3.35,16.73h9.77l1.78-9.03h6.91c3.42,0,6.42-0.59,9.01-1.78c2.58-1.18,4.57-2.86,5.97-5.03s2.1-4.7,2.1-7.6
		C71.63,7.58,70.42,4.85,67.98,2.91"></path>  </g></svg>
                                    :
                                    <span v-if="scope.row.presta_stock === null" class="text-success">-</span>
                                    <strong v-if="scope.row.presta_stock === true" class="text-success">Oui</strong>
                                    <strong v-if="scope.row.presta_stock === false" class="text-danger">Non</strong>
                                </div>

                            </template>
                        </el-table-column>
                        <el-table-column label="Variation">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    <span
                                    :style="scope.row.is_auto_default ? 'background: #67C23A; color: white; padding: 3px 8px; border-radius: 3px; font-weight: bold;' : ''">{{ scope.row.variation_label_value }}
                                <i v-if="scope.row.is_auto_default" class="el-icon-star-on"
                                       title="Variation sélectionnée automatiquement par défaut"></i>
                                </span>
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations value')">
                                    <el-select v-model="scope.row.datasEditInline.variation_value_id"
                                               filterable placeholder="Select">
                                        <el-option v-for="item in variationSize.values" :key="item.id"
                                                   :label="item.value" :value="item.id"></el-option>
                                    </el-select>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="Prix vente HT">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    {{ scope.row.mf_price_public }}
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations mf_price_public')">
                                    <el-input v-model="scope.row.datasEditInline.mf_price_public"
                                              placeholder="Prix de vente HT"></el-input>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="showAllColumns" label="Prix Speedway HT">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    {{ scope.row.price_speedway }}
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations mf_price_public')">
                                    <el-input v-model="scope.row.datasEditInline.price_speedway"
                                              placeholder="Prix Speedway HT"></el-input>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="Prix achat HT">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    {{ scope.row.paht }}
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations mf_price_public')">
                                    <el-input v-model="scope.row.datasEditInline.paht"
                                              placeholder="Prix d'achat HT"></el-input>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="showAllColumns" label="Taux de marge">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    {{ txMarge(scope.row) }}
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations mf_price_public')">

                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="Code barre" prop="ean13">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    {{ scope.row.ean13 }}
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations ean13')">
                                    <el-input v-model="scope.row.datasEditInline.ean13" placeholder="Code barre"></el-input>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="Référence fournisseur" prop="external_ref">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    {{ scope.row.external_ref }}
                                    <span class="text-xs"
                                          title="référence additionnel">({{ scope.row.additional_reference }})</span>
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations external_ref')">
                                    <el-input v-model="scope.row.datasEditInline.external_ref"
                                              placeholder="Référence fournisseur"></el-input>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="showAllColumns" label="Référence fabricant" prop="manufacturer_ref">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    {{ scope.row.manufacturer_ref }}
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations manufacturer_ref')">
                                    <el-input v-model="scope.row.datasEditInline.manufacturer_ref"
                                              placeholder="Référence fabricant"></el-input>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="showAllColumns" label="Date dispo Speedway" prop="date_dispo_pim">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.editMode || scope.row.deleted_at">
                                    {{ scope.row.date_dispo_pim_human }}
                                </template>
                                <template
                                    v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations date_dispo')">
                                    <el-date-picker
                                        v-model="scope.row.datasEditInline.date_dispo_pim"
                                        placeholder="Date dispo Speedway"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                    >
                                    </el-date-picker>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="showAllColumns" label="Référencement Speedway"
                                         prop="referencement_speedway">
                            <template slot-scope="scope">
                                {{ scope.row.referencement_speedway }}
                            </template>
                        </el-table-column>
                        <el-table-column v-if="showAllColumns" label="Par défaut">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.isDefault"
                                           :disabled="scope.row.isDefault || scope.row.deleted_at !== null"
                                           active-color="#13ce66"
                                           inactive-color="#ff4949"
                                           @change="handleChangeDefault(scope.row)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="Activé ?">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.active" active-color="#13ce66"
                                           inactive-color="#ff4949" @change="handleChangeActive(scope.row)"></el-switch>
                                <div>
                                    <svg id="Calque_1" style="height: 12px; fill:cadetblue" version="1.1"
                                         viewBox="0 0 80 52.71" x="0px"
                                         xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink" y="0px">
                                <g>
                                    <path class="st0" d="M67.98,2.91C65.55,0.97,62.09,0,57.62,0H46.54h-3.53H24.89c-3.23,0-6.04,0.49-8.45,1.47
		c-2.4,0.98-4.25,2.36-5.55,4.15s-1.95,3.87-1.95,6.24c0,1.96,0.51,3.54,1.54,4.74s2.25,2.1,3.68,2.68
		c1.42,0.59,3.21,1.16,5.36,1.73c1.9,0.51,3.3,0.98,4.2,1.42s1.35,1.06,1.35,1.85c0,0.92-0.5,1.64-1.49,2.16
		c-0.37,0.2-1.06,0.35-1.77,0.48c-1.24,0.21-2.5,0.31-3.76,0.31H1.46L0,34.54h18.48c3.19,0,6-0.49,8.42-1.47s4.29-2.36,5.6-4.15
		s1.97-3.85,1.97-6.19c0-1.9-0.51-3.43-1.52-4.6c-1.01-1.17-2.22-2.04-3.63-2.61c-1.41-0.57-3.19-1.12-5.34-1.66
		c-1.93-0.5-3.35-0.98-4.27-1.42s-1.38-1.08-1.38-1.9c0-0.95,0.53-1.72,1.59-2.32s2.52-0.9,4.39-0.9L41.55,7.3h9.73h5.13
		c1.74,0,3.08,0.35,4.02,1.06c0.94,0.71,1.41,1.77,1.41,3.18c0,1.87-0.58,3.32-1.75,4.34s-2.92,1.94-5.09,1.94h-5.89l1.34-5.96
		h-9.74l-1.27,5.96l-3.35,16.73h9.77l1.78-9.03h6.91c3.42,0,6.42-0.59,9.01-1.78c2.58-1.18,4.57-2.86,5.97-5.03s2.1-4.7,2.1-7.6
		C71.63,7.58,70.42,4.85,67.98,2.91"></path>  </g></svg>
                                    :
                                    <span v-if="scope.row.presta_activated === null" class="text-success">-</span>
                                    <strong v-if="scope.row.presta_activated === true"
                                            class="text-success">Oui</strong>
                                    <strong v-if="scope.row.presta_activated === false" class="text-danger">Non</strong>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Actions" sortable="custom" width="90">
                            <template slot-scope="scope">
                                <template v-if="!scope.row.inlineLoader">
                                    <a v-if="!scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations')"
                                       href="#" @click.prevent="edit(scope.row)"><i class="fe fe-edit"></i></a>
                                    <a v-if="scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations')"
                                       href="#" @click.prevent="save(scope.row)"><i class="fe fe-save"></i></a>

                                    <a v-if="!scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations transform')"
                                       href="#" @click.prevent="transform(scope.row)">
                                        <i class="fe fe-copy"></i>
                                    </a>
                                    <a v-if="!scope.row.editMode && !scope.row.deleted_at && user.can('edit product variations remove')"
                                       class="text-danger" href="#" @click.prevent="remove(scope.row)"><i
                                        class="fe fe-trash-2"></i></a>
                                    <a v-if="!scope.row.editMode && scope.row.deleted_at && user.can('edit produt variations remove')"
                                       class="text-success" href="#" @click.prevent="restore(scope.row)"><i
                                        class="fe fe-rotate-ccw"></i></a>
                                    <a v-if="!scope.row.editMode && scope.row.deleted_at && user.can('edit produt variations remove')"
                                       class='text-danger' href="#" title='supprimer definitivement'
                                       @click.prevent='forceDelete(scope.row)'><i class='fe fe-trash-2'></i></a>
                                </template>
                                <template v-if="scope.row.inlineLoader">
                                    <i class="el-icon-loading"></i>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </transition>

        <el-dialog
            v-loading="modalGalery.loader"
            :title="'Ajout d\'image pour '+modalGalery.variation.name+' - '+modalGalery.variation.variation_label_value"
            :visible.sync="modalGalery.display" append-to-body top="1vh" width="80%">
            <gallery-selector ref="galerySelector" v-model="modalGalery.selected" :product="product"
                              :variation="modalGalery.variation" selectable
                              @associated="associatedImages"></gallery-selector>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalGalery.display = false">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="dialogRemove" append-to-body title="Attention" top="50vh" width="40%">
            <div class="el-message-box__container">
                <div class="el-message-box__status el-icon-warning"></div>
                <div class="el-message-box__message">
                    <p>Voulez-vous supprimer la variation, elle sera également supprimé sur prestashop à la prochaine
                        synchronisation</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click.prevent="dialogRemove = false"
                >
                    Annuler
                </el-button>
                <el-button
                    type="danger"
                    @click.prevent="handleRemove(true)"
                >
                    Définitivement
                </el-button>
                <el-button
                    type="warning"
                    @click.prenvent="handleRemove(false)"
                >
                    Oui
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Variation from '../../models/Variation';
import { EventBus } from '../../event-bus';
import { calculTauxMarge } from '../../utils/price';

export default {
    data() {
        return {
            loading: false,
            show_deleted_variations: false,
            showAllColumns: false,
            showTable: true,
            variations: [],
            modalGalery: {
                display: false,
                variation: {},
                selected: [],
                loader: false
            },
            formAdd: {
                ean13: null,
                upc: null,
                external_ref: null,
                variation_value_id: null,
                mf_price_public: null,
                date_dispo_pim: null
            },
            formAddRules: {
                variation_value_id: [
                    {
                        required: true,
                        message: 'Le champs est obligatoire',
                        trigger: 'change'
                    }
                ]
            },
            mf_price_public: null,
            price_speedway: null,
            paht: null,
            variationSize: {},
            value: null,
            addMode: false,
            multipleSelection: [],
            dialogRemove: false,
            dialogRemoveVariation: null
        };
    },
    props: {
        product: {
            required: true
        }
    },
    computed: {
        productId() {
            return this.product.id;
        },
        hasEditMode() {
            return this.variations.filter(v => v.editMode).length;
        },
        hasSelection() {
            return this.multipleSelection.length;
        },
        user() {
            return this.$store.getters['app/user'];
        },
        variationsParsed() {
            return this.variations.filter(v => !v.deleted_at || this.show_deleted_variations);
        },
        variationsDeleted() {
            return this.variations.filter(v => v.deleted_at);
        }
    },
    watch: {
        productId(newV, oldV) {
            if (!newV) return;
            this.refresh();
        }
    },
    mounted() {
        this.refresh();
        EventBus.$on('modal.variations-product.closed', () => {
        });
    },
    methods: {
        handleShowAllColumns() {
            this.showTable = false;
            this.showAllColumns = !this.showAllColumns;

            this.$nextTick(() => {
                this.showTable = true;
            });

        },
        handleChangeDefault(variation) {
            if (variation.isDefault) {
                this.variations.map(v => {
                    if (v.id != variation.id) {
                        v.isDefault = false;
                    }
                    return v;
                });
                axios
                    .post('/products/' + this.productId, {
                        product_variation_value_id: variation.id,
                        mode: 'defaultVariation'
                    })
                    .then(r => {
                    })
                    .catch(() => {
                    })
                    .then(() => {
                    });
            }
        },
        handleChangeActive(variation) {
            axios
                .post('/products/' + this.productId + '/variations/' + variation.id, {
                    active: variation.active,
                    mode: 'deactivate'
                })
                .then(r => {
                    let message = variation.active ? 'Variation activée' : 'Variation désactivée';
                    this.$message({
                        message,
                        type: 'success'
                    });
                })
                .catch(() => {
                })
                .then(() => {
                });
        },
        reset() {
            this.addMode = false;
            this.cancelEditMode();
        },
        refresh() {
            this.loading = true;
            this.addMode = false;
            this.fetch().then(() => {
                this.loading = false;
            });
        },
        fetch() {
            return axios
                .get('/products/' + this.productId + '/variations')
                .then(r => {
                    this.variations = Variation.build(r.data.data);
                    this.variationSize = r.data.include.variationSize;
                });
        },
        openGalery(variation) {
            this.modalGalery.display = true;
            this.modalGalery.variation = variation.clone();
            this.modalGalery.selected = [];
            if (this.$refs.galerySelector) this.$refs.galerySelector.refresh();
        },

        modalGalerySave() {
            this.modalGalery.loader = true;
            axios
                .post(
                    '/products/' +
                    this.productId +
                    '/variations/' +
                    this.modalGalery.variation.id,
                    {
                        medias: this.modalGalery.selected,
                        mode: 'gallery'
                    }
                )
                .then(r => {
                    //this.updateProductInList(r.data.data.id, r.data.data);
                    this.modalGalery.display = false;
                })
                .catch(() => {
                })
                .then(() => {
                    this.modalGalery.loader = false;
                });
        },
        add() {
            this.cancelEditMode();
            this.addMode = true;
            this.formAdd = {
                ean13: null,
                upc: null,
                external_ref: null,
                variation_value_id: null
            };
        },
        saveAdd() {
            this.$refs.formAdd.validate(valid => {
                if (valid) {
                    this.loader = true;
                    axios
                        .post(
                            '/products/' + this.productId + '/variations',
                            this.formAdd
                        )
                        .then(r => {
                            let variation = Variation.create(r.data.data);
                            this.$emit('added', {
                                variation,
                                productId: this.productId
                            });
                            this.variations.push(variation);
                            this.cancelAdd();
                        })
                        .catch(() => {
                        })
                        .then(() => {
                            this.loader = false;
                        });
                }
            });
        },
        cancelAdd() {
            this.addMode = false;
        },
        cancelEditMode() {
            this.variations.forEach(v => v.cancelEditMode());
        },
        edit(variation) {
            variation.setEditMode();
        },
        editAll() {
            this.variations.forEach(v => v.setEditMode());
        },
        applyPrice() {
            this.variations.forEach(v => {
                if (this.mf_price_public !== null) {
                    v.datasEditInline.mf_price_public = this.mf_price_public;
                }
                if (this.price_speedway !== null) {
                    v.datasEditInline.price_speedway = this.price_speedway;
                }
                if (this.paht !== null) {
                    v.datasEditInline.paht = this.paht;
                }
            });
        },
        saveAll() {
            var variations = this.variations.filter(v => v.editMode);
            variations.forEach(v => this.save(v));
        },
        save(variation) {
            var datas = variation.saveEditMode();
            variation.inlineLoader = true;
            axios
                .post(
                    '/products/' +
                    this.productId +
                    '/variations/' +
                    variation.id,
                    {
                        ...datas,
                        mode: 'update'
                    }
                )
                .then(r => {
                    variation.update(r.data.data);
                })
                .catch(() => {
                })
                .then(() => {
                    variation.inlineLoader = false;
                });
        },
        handleRemove(forceDelete = false) {
            this.dialogRemove = false;
            this.dialogRemoveVariation.inlineLoader = true;
            let suffixeUrl = forceDelete ? '/force' : '';
            let url = `/products/${this.productId}/variations/${this.dialogRemoveVariation.id}${suffixeUrl}`;
            axios.delete(url)
                .then(r => {
                    this.$emit('removed', {
                        variation: this.dialogRemoveVariation,
                        productId: this.productId
                    });
                    this.dialogRemoveVariation.update(r.data.variation);
                })
                .catch(() => {
                })
                .then(() => {
                    this.dialogRemoveVariation.inlineLoader = false;
                    if (forceDelete) {
                        this.removeToList(this.dialogRemoveVariation);
                    }
                });
        },
        remove(variation) {
            this.dialogRemoveVariation = variation;
            this.dialogRemove = true;
        },
        removeAll() {
            this.$confirm('Voulez-vous supprimer les variations, elle seront également supprimées sur prestashop à la prochaine synchronisation', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    this.multipleSelection.forEach(variation => {
                        variation.inlineLoader = true;
                        axios
                            .delete(
                                '/products/' +
                                this.productId +
                                '/variations/' +
                                variation.id
                            )
                            .then(r => {
                                this.$emit('removed', {
                                    variation,
                                    productId: this.productId
                                });
                                variation.update(r.data.variation);
                            })
                            .catch(() => {
                            })
                            .then(() => {
                                variation.inlineLoader = false;
                            });
                    });
                })
                .catch(() => {
                });
        },
        restore(variation) {
            this.$confirm('Voulez-vous restaurer la variation', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    variation.inlineLoader = true;
                    axios
                        .post(
                            '/products/' +
                            this.productId +
                            '/variations/' +
                            variation.id,
                            {
                                mode: 'restore'
                            }
                        )
                        .then(r => {
                            // console.log(r.data)
                            variation.update(r.data.data);
                        })
                        .catch(() => {
                        })
                        .then(() => {
                            variation.inlineLoader = false;
                        });
                })
                .catch(() => {
                });
        },
        forceDelete(variation) {
            this.$confirm('Voulez-vous supprimer définitivement la variation ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    variation.inlineLoader = true;
                    axios
                        .delete(
                            '/products/' +
                            this.productId +
                            '/variations/' +
                            variation.id +
                            '/force'
                        )
                        .then(r => {
                            this.$emit('removed', {
                                variation,
                                productId: this.productId
                            });
                            variation.update(r.data.variation);
                        })
                        .catch(() => {
                        })
                        .then(() => {
                            variation.inlineLoader = false;
                            this.removeToList(variation);
                        });
                });
        },
        transform(variation) {
            this.$confirm('Voulez-vous transformer la variation en produit ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    variation.inlineLoader = true;

                    axios
                        .post(
                            '/products/' +
                            this.productId +
                            '/variations/' +
                            variation.id +
                            '/transform'
                        )
                        .then(r => {
                            this.$emit('removed', {
                                variation,
                                productId: this.productId
                            });
                            variation.update(r.data.variation);
                            this.$alert('' +
                                '<strong>Voir dans le catalogue :</strong>' +
                                '<a target="_blank" href="' + r.data.link + '">' + r.data.productId + '</a>' +
                                '<div class="alert alert-warning"><p>Attention, il peut y avoir un léger délai avant que le produit ne s\'affiche en raison de l\'indexation. Si rien n\'apparaît, veuillez recharger la page.</p></div>', 'Variation transformer en produit', {
                                confirmButtonText: 'OK',
                                dangerouslyUseHTMLString: true
                            });
                        })
                        .catch(() => {
                        })
                        .then(() => {
                            variation.inlineLoader = false;
                            this.removeToList(variation);
                        });
                });
        },
        removeToList(variation) {
            var index = this.variations.findIndex(v => v.id == variation.id);
            if (index != -1) {
                this.variations.splice(index, 1);
            }
        },
        updateToList(variation) {
            var index = this.variations.findIndex(v => v.id == variation.id);
            if (index != -1) {
                this.variations.splice(index, 1, variation);
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        associatedImages({ product, variation }) {
            //this.variation.update(variation);
            var variationFinded = this.variations.find(
                v => (variation.id = v.id)
            );
            if (variationFinded) {
                variationFinded.update(variation);
            }
            this.modalGalery.variation = variation;
        },
        addRowClass(row, rowIndex) {
            return row.row.deleted_at ? 'deleted-row' : '';
        },
        txMarge(product) {
            return calculTauxMarge(product);
        }
    }
};
</script>
<style lang="scss">
.product-variations {
    .silent-link {
        &:hover {
            text-decoration: none;
        }
    }

    .placeholder-img {
        text-align: center;
        width: 120px;
        height: 90px;
        background: #e7e7e7;
        vertical-align: middle;
        display: table-cell;
        color: #007bfffc;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .deleted-row {
        opacity: .3;
        cursor: not-allowed;
    }

    .table-wrapper-overflow {
        overflow-x: auto;
        width: 100%;
    }
}
</style>
